import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App';
import { appAccessDisabled } from './app/access';
import { AuthProvider } from './features/auth/AuthProvider';
import { ToastProvider } from './components/ToastProvider';
import { AccessClosedPage } from './pages/AccessClosedPage';
import './styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {appAccessDisabled ? (
      <AccessClosedPage />
    ) : (
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AuthProvider><ToastProvider><App /></ToastProvider></AuthProvider>
        </QueryClientProvider>
      </BrowserRouter>
    )}
  </StrictMode>,
);
